export const environment = {
  production: true,
  webUrl: 'https://www.ihmusedparts.com',
  apiUrl: 'https://api-prod.ihmparts.com/api/v1',
  webDescription: 'High Quality and Low Cost Heavy Equipment Parts'
};
